import { render, staticRenderFns } from "./Studios.vue?vue&type=template&id=06b2e2c8"
import script from "./Studios.vue?vue&type=script&lang=js"
export * from "./Studios.vue?vue&type=script&lang=js"
import style0 from "./Studios.vue?vue&type=style&index=0&id=06b2e2c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports